import styled from 'styled-components'

export const HR = styled.hr`
  width: 100%;
  //align: center;
  border: none;
  height: 1px;
  background: linear-gradient(
    to right,
    rgba(14, 28, 67, 0.5),
    1%,
    rgba(14, 28, 67, 0.5),
    25%,
    rgba(39, 210, 234, 0.5),
    50%,
    rgba(39, 210, 234, 0.5),
    75%,
    rgba(14, 28, 67, 0.5)
  );
  box-shadow: 0 0 10px rgba(39, 210, 234, 0.4), 0 0 20px rgba(39, 210, 234, 0.6);
  //margin-top: 2%;
  //margin-bottom: 2%;
`

export const HRDark = styled.hr`
  width: 100%;
  //align: center;
  border: none;
  height: 1px;
  background: linear-gradient(
    to right,
    rgba(14, 28, 67, 0.5),
    1%,
    rgba(14, 28, 67, 0.5),
    25%,
    rgba(12, 92, 146, 0.3),
    50%,
    rgba(12, 92, 146, 0.3),
    75%,
    rgba(14, 28, 67, 0.5)
  );
  box-shadow: 0 0 10px rgba(39, 210, 234, 0.1), 0 0 20px rgba(39, 210, 234, 0.2);
  //margin-top: 2%;
  //margin-bottom: 2%;
`
